"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextColorAndDisabledClassesMap = exports.getTextColorClassesMap = exports.getContainerColorAndDisabledClassesMap = exports.getContainedColorClassesMap = void 0;
var enums_1 = require("../../enums");
var getContainedColorClassesMap = function (classes, color) {
    var containedColorClassesMap = new Map([
        [enums_1.Color.primary, classes.containedPrimary],
        [enums_1.Color.secondary, classes.containedSecondary],
        [enums_1.Color.tertiary, classes.containedTertiary],
        [enums_1.Color.warning, classes.containedWarning],
        [enums_1.Color.error, classes.containedError],
    ]);
    return containedColorClassesMap.get(color);
};
exports.getContainedColorClassesMap = getContainedColorClassesMap;
var getContainerColorAndDisabledClassesMap = function (classes, color) {
    var containerColorAndDisabledClassesMap = new Map([
        [enums_1.Color.primary, classes.disabledContainedPrimary],
        [enums_1.Color.secondary, classes.disabledContainedSecondary],
        [enums_1.Color.tertiary, classes.disabledContainedTertiary],
    ]);
    return containerColorAndDisabledClassesMap.get(color);
};
exports.getContainerColorAndDisabledClassesMap = getContainerColorAndDisabledClassesMap;
var getTextColorClassesMap = function (classes, color) {
    var textColorClassesMap = new Map([
        [enums_1.Color.primary, classes.textPrimary],
        [enums_1.Color.secondary, classes.textSecondary],
        [enums_1.Color.tertiary, classes.textTertiary],
    ]);
    return textColorClassesMap.get(color);
};
exports.getTextColorClassesMap = getTextColorClassesMap;
var getTextColorAndDisabledClassesMap = function (classes, color) {
    var textColorAndDisabledClassesMap = new Map([
        [enums_1.Color.primary, classes.disabledTextPrimary],
        [enums_1.Color.secondary, classes.disabledTextSecondary],
        [enums_1.Color.tertiary, classes.disabledTextTertiary],
    ]);
    return textColorAndDisabledClassesMap.get(color);
};
exports.getTextColorAndDisabledClassesMap = getTextColorAndDisabledClassesMap;
